import { configureStore } from "@reduxjs/toolkit"
import notificationsReducer from "./slices/notificationsSlice"
import ticketsReducer from "./slices/ticketsSlice"
import messagesReducer from "./slices/messagesSlice"
import announcementsReducer from "./slices/announcementsSlice"
import blogReducer from "./slices/blogSlice"
import roomsReducer from "./slices/roomsSlice"
import discountsReducer from "./slices/discountsSlice"
import usersReducer from "./slices/usersSlice"
// Add the buildings reducer import
import buildingsReducer from "./slices/buildingsSlice"
import guestsReducer from "./slices/guestsSlice"

// Add the buildings reducer to the store configuration
export const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    tickets: ticketsReducer,
    messages: messagesReducer,
    announcements: announcementsReducer,
    blog: blogReducer,
    rooms: roomsReducer,
    discounts: discountsReducer,
    users: usersReducer,
    buildings: buildingsReducer,
    guests: guestsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          // Add specific action types here if needed
        ],
        // Ignore these field paths in the state
        ignoredPaths: [
          // Add specific paths here if needed
        ],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
